import '@styles/general.scss';
import {ToastContainer} from 'react-toastify';
import Auth from '@/screens/Auth';
import styles from './appAuth.module.scss';

const AppAuth = () => {
    return (
        <main className={styles.authApp}>
            <Auth />
            <ToastContainer stacked position={'bottom-left'} />
        </main>
    );
};

export default AppAuth;
